import View from "../../../assets/js/view";
import { css, ajax } from "../../../assets/js/utils";
import radio from "../../../assets/js/radio";

export default class ContactForm extends View {
  ui = {
    form: "form[0]",
    backdrop: ".js-contactFormBackdrop[0]",
  };

  events = {
    "click @ui.backdrop": "handleBackdropClick",
  };

  init() {
    this.bind("open");

    radio.on("contact-form:open", this.open);
  }

  open() {
    this.el.classList.remove("is-hidden");
  }

  close() {
    this.el.classList.add("is-hidden");
  }

  handleBackdropClick(e) {
    this.close();
  }
}
